import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { headerIds, moduleName } from '../constants-types/constants';
import {
    Inspire2Link,
    design2Home,
    design2Team,
    diagnose2RoutePath,
    dreamTeamsRoutePath,
    dreamTeamsSelfServeRoutePath,
    hire2RoutePath,
    hubAndSpokeRoutePath
} from '../constants-types/Route.constants';
import { HttpHeaderContentType } from '../shared/Enums';

/**
 * Header-related functions.
 */
@Injectable({ providedIn: 'root' })
export class HeaderService {
    private isDemoData = false;

    constructor() {}

    setIsDemoData(isDemoData: boolean) {
        this.isDemoData = isDemoData;
    }

    getOptions(acceptContentType?: string) {
        const headerContentType = HttpHeaderContentType.JSON;
        let headers = new HttpHeaders({
            'Content-Type': headerContentType,
            Accept: acceptContentType || headerContentType
        });

        if (this.isDemoData) {
            headers = headers.set('X-IsDemoEnabled', 'true');
        }

        headers = this.appendRequestingModuleHeader(
            headers,
            window.location.pathname
        );
        return {
            headers,
            withCredentials: true,
            observe: 'response' as const,
            params: {}
        };
    }

    appendRequestingModuleHeader(
        headers: HttpHeaders,
        route: string
    ): HttpHeaders {
        // the following custom header is appended for all outgoing requests from Design Self Serve,
        // Hire Hero, or Diagnose for use by the new attribute-based permissioning system
        switch (true) {
            case route.includes(dreamTeamsSelfServeRoutePath):
            case route.includes(design2Home):
            case route.includes(design2Team):
            case route.includes(hubAndSpokeRoutePath):
                return this.getHeaderModule(
                    headers,
                    dreamTeamsSelfServeRoutePath
                );
            case route.includes(dreamTeamsRoutePath):
                return this.getHeaderModule(headers, dreamTeamsRoutePath);
            // Hire beta users shouldn't be on new permissions, so we won't add the header here if this is a Hire beta company
            case route.includes(hire2RoutePath):
                return this.getHeaderModule(headers, hire2RoutePath);
            case route.includes(diagnose2RoutePath):
                return this.getHeaderModule(headers, diagnose2RoutePath);
            case route.includes(Inspire2Link):
                return this.getHeaderModule(headers, Inspire2Link);
            default:
                return headers;
        }
    }

    private getHeaderModule(headers, key): HttpHeaders {
        const modules = {
            [dreamTeamsSelfServeRoutePath]: moduleName.designSelfServe,
            [dreamTeamsRoutePath]: moduleName.designLegacy,
            [hire2RoutePath]: moduleName.hireHero,
            [diagnose2RoutePath]: moduleName.diagnose2,
            [Inspire2Link]: moduleName.inspire2
        };
        return headers.append(headerIds.requestingModule, modules[key]);
    }
}
